import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { formatDate } from '../utils/date';
import { Badge } from './ui/badge';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from './ui/table';
import { Button } from './ui/button';
import { toast } from 'react-hot-toast';

const LogList = () => {
  const [logs, setLogs] = useState([]);
  // Auth helper
  const getAuthHeaders = () => {
    const token = localStorage.getItem('gads_token');
    return {
      'Content-Type': 'application/json',
      ...(token ? { 'Authorization': 'Bearer ' + token } : {}),
    };
  };

  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({
    limit: 100
  });

  useEffect(() => {
    fetchLogs();
  }, [filters]);

  const fetchLogs = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/logs`, { params: filters });
      setLogs(response.data);
    } catch (error) {
      console.error('Error fetching logs:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleClearLogs = async () => {
    try {
      setLoading(true);
      await axios.delete(`${process.env.REACT_APP_API_URL}/api/logs`);
      toast.success('Đã xóa tất cả logs thành công');
      fetchLogs();
    } catch (error) {
      console.error('Error clearing logs:', error);
      toast.error('Lỗi khi xóa logs');
    } finally {
      setLoading(false);
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'success':
        return 'bg-green-100 text-green-800';
      case 'error':
        return 'bg-red-100 text-red-800';
      case 'warning':
        return 'bg-yellow-100 text-yellow-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };

  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center">
        <h2 className="text-md font-bold">Activity Logs</h2>
        <div className="flex gap-2">
          <Button onClick={handleClearLogs} className="text-[10px]" variant="destructive">Clear</Button>
          <Button onClick={fetchLogs} className="text-[10px]">Refresh</Button>
        </div>
      </div>

      <div className="border rounded-lg overflow-hidden bg-white">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead className="text-[10px]">Time</TableHead>
              <TableHead className="text-[10px]">Account</TableHead>
              <TableHead className="text-[10px]">Action</TableHead>
              <TableHead className="text-[10px]">Status</TableHead>
              <TableHead className="text-[10px]">Message</TableHead>
              <TableHead className="text-[10px]">Details</TableHead>
              <TableHead className="text-[10px]">Error</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {logs.map((log) => (
              <TableRow key={log.id}>
                <TableCell className="text-[10px]">{formatDate(log.created_at)}</TableCell>
                <TableCell className="text-[10px]">{log.account_id}</TableCell>
                <TableCell className="text-[10px]">{log.action}</TableCell>
                <TableCell>
                  <Badge className={`${getStatusColor(log.status)} text-[10px]`}>
                    {log.status}
                  </Badge>
                </TableCell>
                <TableCell className="text-[10px]">{log.message}</TableCell>
                <TableCell className="text-[10px] w-[200px]">
                  {log.details && (
                    <div className="text-[10px] text-wrap">
                      {JSON.stringify(log.details, null, 2)}
                    </div>
                  )}
                </TableCell>
                <TableCell className="text-[10px] max-w-[200px]">
                  {log.error && (
                    <pre className="text-[10px] text-red-600 whitespace-pre-wrap text-wrap">
                      {log.error}
                    </pre>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
};

export default LogList; 